<template>
  <div class="common-page commission-sharing-rule-config">
    <div class="right-box" v-loading="loading">
      <div class="right-content">
        <div class="config-list">
          <div class="config-list-title">
            <div class="config-list-title-txt">
              <span>运费溢价系数配置</span>
            </div>
            <div class="config-list-title-btns">
              <template v-if="isEdit">
                <el-button type="text" @click="isEdit = false">取消</el-button>
                <el-button type="text" @click="handleSave4()">保存</el-button>
              </template>
              <template v-else>
                <el-button type="text" @click="isEdit = true">编辑</el-button>
              </template>
            </div>
          </div>
          <div class="warning-box">
            <div class="custom-tip">
              <el-image :src="require('@/assets/imgs/price-tip.png')" class="tip-img"></el-image>
              <div class="tip-box">
                <div class="tip-title">
                  <span>运费溢价系数说明</span>
                </div>
                <div class="tip-list">
                  （1）以发货当天是否为特殊日期为准，若发货当天遇到多个重叠选项（如既是周末又是普通节假日），则以系数高的为准；
                </div>
                <div class="tip-list">
                  （2）预约单的运费系数是判断预约发货日期是否为特殊日期，若是则先计算特殊日期溢价系数后再计算预约单的运费系数。
                </div>
              </div>
            </div>
          </div>
          <el-row :gutter="20" class="form-box">
            <el-form ref="form4" :model="form" :rules="rules" label-position="top">
              <el-col :span="6">
                <el-form-item label="周末运费系数：" prop="freightCoeffWeekend">
                  <el-input
                    :disabled="!isEdit"
                    clearable
                    placeholder="请输入"
                    v-model="form.freightCoeffWeekend"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="普通节假日运费系数：" prop="freightCoeffHoliday">
                  <el-input
                    :disabled="!isEdit"
                    clearable
                    placeholder="请输入"
                    maxlength="11"
                    v-model="form.freightCoeffHoliday"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="春节运费系数：" prop="freightCoeffSpringFestival">
                  <el-input
                    :disabled="!isEdit"
                    clearable
                    placeholder="请输入"
                    v-model="form.freightCoeffSpringFestival"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="预约单运费系数：" prop="freightCoeffReserve">
                  <el-input
                    :disabled="!isEdit"
                    clearable
                    placeholder="请输入"
                    v-model="form.freightCoeffReserve"></el-input>
                </el-form-item>
              </el-col>
            </el-form>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OperateBox from "@/components/OperateBox.vue";
import CustomTable from "@/components/CustomTable.vue";
import {
  getConfig,
  setConfig
} from "../api";
import { validatePrice, validatePhone } from "@/utils/validate";
export default {
  name: "BasicBusinessRuleConfig",
  components: {
    OperateBox,
    CustomTable,
  },
  data() {
    return {
      form: {
        "freightCoeffHoliday": "",
        "freightCoeffReserve": "",
        "freightCoeffSpringFestival": "",
        "freightCoeffWeekend": ""
      },
      isEdit: false,
      loading: false,
      rules: {
        freightCoeffHoliday: [
          { required: true, message: "不能为空" },
          { validator: validatePrice, trigger: "blur" },
        ],
        freightCoeffReserve: [
          { required: true, message: "不能为空" },
          { validator: validatePrice, trigger: "blur" },
        ],
        freightCoeffSpringFestival: [
          { required: true, message: "不能为空" },
          { validator: validatePrice, trigger: "blur" },
        ],
        freightCoeffWeekend: [
          { required: true, message: "不能为空" },
          { validator: validatePrice, trigger: "blur" },
        ]
      },
    };
  },
  created() {
    this.getConfig();
  },
  mounted() {},
  methods: {
    getConfig() {
      this.loading = true;
      getConfig()
        .then((res) => {
          this.loading = false;
          if (res.code === 200) {
            this.form = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSave4() {
      // this.isEdit = false;
      this.$refs.form4.validate((valid) => {
        if (valid) {
          this.setRebateDriverConfigData();
          // this.form.box1[index].isEdit = false;
        } else {
          return false;
        }
      });
    },
    setRebateDriverConfigData() {
      setConfig({
        "freightCoeffHoliday": this.form.freightCoeffHoliday,
        "freightCoeffReserve": this.form.freightCoeffReserve,
        "freightCoeffSpringFestival": this.form.freightCoeffSpringFestival,
        "freightCoeffWeekend": this.form.freightCoeffWeekend,
      }).then((res) => {
        if (res.code === 200) {
          this.isEdit = false;
          this.$message.success("保存成功");
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.commission-sharing-rule-config {
  display: flex;
  flex-direction: row;
  .left-box {
    width: 20%;
    height: 100%;
    //background-color: #ffffff;
    flex-shrink: 0;
    padding: 0.2rem 0 0.2rem 0.2rem;
    box-sizing: border-box;
    .left-content {
      width: 100%;
      height: 100%;
      background-color: #ffffff;
      border-radius: 0.08rem;
      padding: 0.2rem;
      box-sizing: border-box;
      overflow-y: auto;
      .list {
        width: 100%;
        height: 0.4rem;
        color: #434343;
        display: flex;
        align-items: center;
        padding-left: 0.1rem;
        box-sizing: border-box;
        font-size: 0.16rem;
        cursor: pointer;
        border-radius: 0.04rem;
      }
      .select-dispatch {
        background: rgba(18, 105, 255, 0.05);
        color: #1269ff;
        position: relative;
        &:before {
          position: absolute;
          left: 0;
          top: 0;
          content: "";
          width: 0.02rem;
          height: 100%;
          background-color: #1269ff;
        }
      }
    }
  }
  .right-box {
    flex: 1;
    padding: 0.2rem;
    box-sizing: border-box;

    .right-content {
      width: 100%;
      height: 100%;
      overflow-y: auto;
      overflow-x: hidden;
      background-color: #ffffff;
      border-radius: 0.08rem;
      padding: 0.1rem;
      box-sizing: border-box;
      .config-list {
        border-bottom: 0.01rem solid #dce5f5;
        padding-bottom: 0.1rem;
        margin-bottom: 0.1rem;
      }
      .config-list:nth-last-of-type(1) {
        border-bottom: none;
      }
    }
    .config-list-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 0.1rem;
      .config-list-title-txt {
        span:nth-of-type(1) {
          color: #000000;
          font-size: 0.16rem;
        }
        span:nth-of-type(2) {
          color: #8c8c8c;
          font-size: 0.12rem;
          padding-left: 0.1rem;
        }
      }
      .config-list-title-btns {
      }
    }
  }
  .form-box1 {
    padding: 0.1rem 0.1rem 0.2rem;
    .form-box-item-title {
      background: #f0f5ff;
      height: 0.32rem;
      display: flex;
      align-items: center;
      color: #000000;
      font-size: 0.14rem;
      .dot {
        position: relative;
        &:before {
          position: absolute;
          content: "*";
          color: red;
          left: -0.1rem;
          top: 0.04rem;
        }
      }
    }
    .form-box-item-content {
      display: flex;
      align-items: center;
      width: 100%;
      height: 0.5rem;
      .content-list {
        display: flex;
        align-items: center;
        height: 100%;
        width: 100%;
        ::v-deep .el-form-item {
          margin-bottom: 0;
        }
      }
    }
    .form-box-item-content:nth-of-type(2n-1) {
      background: #fbfcff;
    }
  }
  .custom-tip {
    font-size: 0.16rem;
    padding: 0.16rem 0.2rem;
    background: rgba(18, 105, 255, 0.05);
    box-sizing: border-box;
    margin: 0 0.16rem;
    border-radius: 0.03rem;
    border: 0.01rem dashed #1269ff;
    display: flex;
    align-items: center;
    .tip-img {
      width: 0.44rem;
      height: 0.44rem;
      flex-shrink: 0;
      margin-right: 0.2rem;
    }
    .tip-title {
      display: flex;
      align-items: center;
      padding-bottom: 0.06rem;
      i {
        color: #cf9236;
        margin-right: 0.03rem;
      }
      span {
        color: #000000;
        font-size: 0.14rem;
      }
    }
    .tip-list {
      line-height: 0.26rem;
      box-sizing: border-box;
      font-size: 0.12rem;
      color: #434343;
    }
  }
}
</style>
